import React, { Component, Fragment } from "react";

export default class SelectCampo extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                    <form>
                        <div className="form-group">
                            <label>Modalidade: </label>
                            <select name="selectModalidade" onChange={this.props.selectModalidade} className="form-control" id={this.props.idComponente || "selectModalidade"}>
                                <option value="Todas">Todas</option>
                                <option value="Iniciação Profissional à Distância">Iniciação Profissional à Distância</option>
                                <option value="Iniciação Profissional Presencial">Iniciação Profissional Presencial</option>
                                <option value="Qualificação Profissional Presencial">Qualificação Profissional Presencial</option>
                                <option value="Qualificação Profissional a Distância">Qualificação Profissional a Distância</option>
                                <option value="Qualificação Profissional - Itinerário V Ensino Médio">Qualificação Profissional - Itinerário V Ensino Médio</option>
                                <option value="Aperfeiçoamento/Espec.Profis.a Distância">Aperfeiçoamento/Espec.Profis.a Distância</option>
                                <option value="Aperfeiçoamento/Espec.Profiss.Presencial">Aperfeiçoamento/Espec.Profiss.Presencial</option>
                                <option value="Técnico de Nível Médio Presencial">Técnico de Nível Médio Presencial</option>
                                <option value="Técnico de Nível Médio a Distância">Técnico de Nível Médio a Distância</option>
                                <option value="Técnico N.Médio Presencial Itinerário V">Técnico N.Médio Presencial Itinerário V</option>
                                <option value="Aprendizagem Industrial Presencial">Aprendizagem Industrial Presencial</option>
                                <option value="Aprendizagem Industrial a Distância">Aprendizagem Industrial a Distância</option>
                                <option value="Aprendizagem Industrial Técnica Presenc.">Aprendizagem Industrial Técnica Presenc.</option>
                                <option value="Graduação Tecnológica Presencial">Graduação Tecnológica Presencial</option>
                                <option value='Pós-Graduação "lato sensu" - Especializa'>Pós-Graduação "lato sensu" - Especializa</option>
                                <option value="Cursos de Extensão Presencial">Cursos de Extensão Presencial</option>
                                <option value="Cursos de Extensão a Distância">Cursos de Extensão a Distância</option>
                            </select>
                        </div>
                    </form>
            </Fragment>
        )
    }
}